import axios from 'axios';
import Qs from 'qs'; //将参数转换为query参数, 利用qs
import $router from '../router';
import $store from '../store';
import Vue from 'vue';
import {
  Message,
  MessageBox
} from 'element-ui'

// =======
var err_tk = false;
var that = this;
export function request(config) {
  //1、创建axios的实例
  const instance = axios.create({
    baseUrl: Vue.prototype.BASE_URL,
    timeout: 10000,
    headers: {
      "Content-Type": "application/json"
    },
    params: config.method === 'get' ? config.data : {},
    method: config.method ? config.method : 'post', //默认post请求
  })
  //2、axios拦截器的使用
  // 2.1请求拦截的作用
  instance.interceptors.request.use(config => {
    // 拼接URL并去除可能存在的中的==%E2%80%8B==字符
    let newurl = Vue.prototype.BASE_URL + config.url;
    //newurl = decodeURI(encodeURI(newurl).replace(/%E2%80%8B/g, ""));
    config.url = newurl;
    //在请求头中添加token
    let token = '';
    if (localStorage.getItem(token)) {
      token = localStorage.getItem(token);
    }
    config.headers.token = token;
    //比如每次发送请求前显示加载图
    return config
  }, err => {
    return err
  });
  //    2.2响应拦截的作用
  instance.interceptors.response.use(res => {
    //请求得到响应并获得数据
    if (res.status === 200) {
      //return res.data;
      if (res.data.code === '0') {
        return res.data;
      } else if (res.data.code === '401' || res.data.code === '403') {
        // 清空所有用户信息本地存的以及状态管理里面的
        $store.commit('login/EXIT_LGOIN')
        localStorage.setItem('fullPath', JSON.stringify($router.currentRoute.fullPath))
        //跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
        $router.replace({
          path: '/login',
          query: {
            redirect: $router.currentRoute.fullPath
          }
        });
        return res.data;
      } else if (res.data.code === '-1') {

        clearTimeout(timer);
        if (!err_tk) {
          Message({
            message: res.data.msg,
            duration: 2000,
            type: 'error'
          });
          err_tk = true

          var timer = setTimeout(() => {
            err_tk = false
          }, 2000);
        }

        return res.data;
      }

    } //end if===200

  }, err => {


    Message({
      message: err
    });
    return err;
  });
  //发送真正的网络请求
  return instance(config)
}



// WEBPACK FOOTER //
// ./src/network/request.js